import { AxiosRequestConfig } from 'axios'

export interface AutomaticCampaignsParams {
  startDate: string
  endDate: string
}

export interface AutomaticCampaign {
  pushTitle?: string | null
  pushesSent: number
  pushesReceived: number
  pushesOpened: number
  walkthrough: number
  benefitsReceived: number
  benefitsRedeemed: number
}

export interface AutomaticCampaignsResponse {
  data: AutomaticCampaign[]
}

const getAutomaticCampaigns = (params: AutomaticCampaignsParams): AxiosRequestConfig => ({
  url: '/dashboard/automatic-campaigns',
  method: 'GET',
  params,
})

export { getAutomaticCampaigns }
